import * as React from "react";
import classnames from "classnames";
import { ButtonBase, ButtonBaseProps } from "@mui/material";
import "./CDButton.scss";
import { CDButtonType } from "./CDButtonType";

export interface CDButtonProps extends Omit<ButtonBaseProps, "ref" | "color"> {
  buttonType: CDButtonType;
  buttonRef?: React.Ref<HTMLButtonElement>;
}

export function CDButton(props: CDButtonProps) {
  const { buttonType, buttonRef, ...buttonProps } = props;
  const classNames = classnames([
    "btn",
    buttonType,
    "cdata-button",
    props.className,
  ]);

  return (
    <ButtonBase {...buttonProps} className={classNames} ref={buttonRef}>
      {props.children}
    </ButtonBase>
  );
}
